import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiCaptchaComponent } from './fi-captcha.component';
import { RecaptchaLoaderService, RecaptchaModule } from 'ng-recaptcha';
import { FiCaptchaLoaderService } from '@fi-app/utilities/captcha/fi-captcha-loader.service';

@NgModule({
    imports: [CommonModule, RecaptchaModule],
    declarations: [FiCaptchaComponent],
    providers: [
        {
            provide: RecaptchaLoaderService,
            useValue: new FiCaptchaLoaderService(),
        },
    ],
    exports: [FiCaptchaComponent],
})
export class FiCaptchaModule {}
